"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var limitList = function (list, limit) {
    if (limit === void 0) { limit = 0; }
    if (limit <= 0 || limit >= list.length) {
        return list;
    }
    return list.slice(0, limit);
};
exports.default = limitList;
//# sourceMappingURL=limitList.js.map